import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { MobileMenu } from './MobileMenu';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
export function AppShell() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    if (!mobileMenuOpen) {
      return;
    }
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [mobileMenuOpen]);
  return <div className="flex h-screen w-full overflow-hidden bg-slate-100" data-id="element-324" data-mp="7snyzioh12a8">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(c => !c)} data-id="element-325" data-mp="2uusspn6489y" />
      <div className="flex flex-1 flex-col overflow-hidden" data-id="element-326" data-mp="2ss4qb5ksp7v">
        <TopBar onOpenMenu={() => setMobileMenuOpen(true)} data-id="element-327" data-mp="10as6ftkuof33" />
        <main className="flex-1 overflow-y-auto" data-id="element-328" data-mp="viqp3t8try67">
          <Outlet data-id="element-329" data-mp="vhz39a515et4" />
        </main>
      </div>
      <MobileMenu open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} data-id="element-330" data-mp="2betf2db7i8m8" />
    </div>;
}